<div class="content-wrapper">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section class="users-list-wrapper">
      <div class="card">
        <app-role-list></app-role-list>
        <core-sidebar class="modal modal-slide-in sidebar-todo-modal fade" name="new-role-sidebar"
          overlayClass="modal-backdrop">
          <app-new-role-sidebar></app-new-role-sidebar>
        </core-sidebar>
      </div>
    </section>
  </div>
</div>